import React, { useState, useEffect } from "react";
import { Form, Grid } from "semantic-ui-react";
import Joi from "joi";
import { isEmpty, map, includes, toLower, trim, isEqual, get } from "lodash";
import PropTypes from "prop-types";
// Components
import Input from "@Components/Input";
import IKModal from "@Components/IkModal";
// Modals
import ConfirmModal from "@Modals/ConfirmModal";
// redux
import genericAction from "@Actions/generic";
import { connect } from "react-redux";
// Styles
import styles from "./styles.module.css";

const TypeCompanyCrud = ({ tableValue, modalCrud, onClose, apiData, dispatch, tagsList, route }) => {
	const schema = Joi.object().keys({
		nametyping: Joi.string().min(4).messages({
			"string.min": "Nombre debe tener mínimo 4 caracteres",
			"string.empty": "Nombre es un campo requerido",
		}),
		nombretypingRepet: Joi.string().messages({
			"string.min": "Nombre debe tener mínimo 4 caracteres",
			"string.empty": "Nombre es un campo requerido",
		}),
	});

	const [open, setOpen] = useState(false);
	const [errors, setErrors] = useState([]);
	const [initialFormData, setInitialFormData] = useState([]);
	const [modalOption, setModalOption] = useState();
	const [formData, setFormData] = useState({
		nametyping: "",
		category: "",
		departament: "",
		color: "",
	});

	useEffect(() => {
		setModalOption(modalCrud);

		if (!isEmpty(tableValue)) {
			setFormData({
				nametyping: tableValue.name,
			});

			setInitialFormData({
				nametyping: tableValue.name,
			});
		} else {
			setFormData({
				nametyping: "",
			});

			setInitialFormData({
				nametyping: "",
			});
		}
	}, [tableValue]);
	// save handlers
	const handlerSaved = async () => {
		let nombretypingRepet = "ejemplo";

		if (modalOption === "Add") {
			map(tagsList, (item) => {
				if (includes(toLower(item.name), toLower(formData.nametyping))) {
					nombretypingRepet = "";
				}
			});
		}

		const validation = schema.validate(
			{
				nametyping: formData.nametyping,
				nombretypingRepet,
			},
			{ abortEarly: false }
		);
		if (validation.error) {
			const { details } = validation.error;
			let errorsVal = {
				nametyping: "",
				nombretypingRepet: "",
			};
			map(details, (item) => {
				errorsVal = { ...errorsVal, [item.context.key]: item.message };
			});
			setErrors(errorsVal);
		} else {
			let nameValue = formData.nametyping;
			if (isEmpty(formData.nametyping)) {
				nameValue = null;
			}
			const data = { name: trim(nameValue) };

			if (modalOption === "Add") {
				const dataAdd = await dispatch(genericAction({ method: "post", route, body: data }));
				if (!isEmpty(dataAdd)) {
					setFormData({
						nametyping: "",
						// category: "",
						// departament: "",
						// color: "",
					});
					apiData("Add");
				}
			} else {
				const dataEdit = await dispatch(genericAction({ method: "patch", route: `${route}/${tableValue.tagId}`, body: data }));
				if (!isEmpty(dataEdit)) {
					apiData("Edit");
				}
			}
		}
	};

	// input handlers
	const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});
	};
	// modal handlers
	const cancelModal = () => {
		onClose();
	};

	const modalOpen = () => {
		if (isEqual(initialFormData, formData)) {
			cancelModal();
		} else if (open) {
			setOpen(false);
		} else {
			setOpen(true);
		}
	};

	return (
		<>
			<IKModal
				title={modalOption === "Add" ? "Agregar Tipo de Compañía" : `Tipo de Compañía: ${get(tableValue, "name", "")}`}
				id={tableValue.tagId}
				mode={modalOption}
				setMode={setModalOption}
				onClose={modalOpen}
				onSuccess={handlerSaved}
				size="tiny">
				<Grid className={styles.grid}>
					<Grid.Row className={styles.grid}>
						<Grid.Column width={16} className={styles.grid}>
							<fieldset className={styles.fieldset}>
								<div>
									<Form>
										<Input
											value={formData.nametyping}
											icon="unordered list"
											required
											disabled={modalOption === "Watch"}
											label="Nombre:"
											placeholder="nombre"
											name="nametyping"
											fluid
											error={!isEmpty(errors.nametyping) && { content: errors.nametyping, pointing: "above" }}
											onChange={handleInput}
										/>
									</Form>
								</div>
							</fieldset>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</IKModal>
			{open && (
				<ConfirmModal
					visible
					header="Salir del formulario"
					content="Está seguro que desea salir del formulario"
					onConfirm={cancelModal}
					onDismiss={modalOpen}
				/>
			)}
		</>
	);
};

function mapStateToProps({ user, company }) {
	return {
		companies: [],

		companyName: company.name,
		userName: user.name,
	};
}

TypeCompanyCrud.propTypes = {
	tableValue: PropTypes.array,
	onClose: PropTypes.func,
	apiData: PropTypes.func,
	dispatch: PropTypes.func,
	tagsList: PropTypes.array,
	modalCrud: PropTypes.string,
	route: PropTypes.string,
};
export default connect(mapStateToProps)(TypeCompanyCrud);
